import api from './api';

export const getAllProjects = async () => {
  const response = await api.get('/projects/');
  return response.data;
};

export const getMyProjects = async () => {
  const response = await api.get('/projects/my-projects');
  return response.data;
};

export const getProjectById = async (projectId) => {
  const response = await api.get(`/projects/${projectId}`);
  return response.data;
};

export const createProject = async (projectData) => {
  const response = await api.post('/projects/', projectData);
  return response.data;
};

export const updateProject = async (projectId, projectData) => {
  const response = await api.put(`/projects/${projectId}`, projectData);
  return response.data;
};

export const deleteProject = async (projectId) => {
  const response = await api.delete(`/projects/${projectId}`);
  return response.data;
};

export const uploadProjectScopeFile = async (projectId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/projects/${projectId}/scope/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const submitProjectScope = async (projectId, scope, fileMeta = {}) => {
  const response = await api.post(`/projects/${projectId}/scope`, {
    project_scope: scope,
    scope_file_path: fileMeta.scope_file_path || null,
    scope_file_name: fileMeta.scope_file_name || null
  });
  return response.data;
};

export const getProjectScopeFileUrl = async (projectId) => {
  const response = await api.get(`/projects/${projectId}/scope/file`);
  return response.data.url;
};

export const approveProjectScope = async (projectId, approved) => {
  const response = await api.post(`/projects/${projectId}/scope/approve`, { approved });
  return response.data;
};

export const getProjectMilestones = async (projectId) => {
  const response = await api.get(`/projects/${projectId}/milestones`);
  return response.data;
};

export const markMilestoneComplete = async (milestoneId) => {
  const response = await api.post(`/projects/milestones/${milestoneId}/complete`);
  return response.data;
};

export const approveMilestone = async (milestoneId) => {
  const response = await api.post(`/projects/milestones/${milestoneId}/approve`);
  return response.data;
};

export const updateProjectStatus = async (projectId, status) => {
  const response = await api.patch(`/projects/${projectId}/status`, { status });
  return response.data;
};

export const requestMilestoneCompletion = async (milestoneId) => {
  const response = await api.post(`/projects/milestones/${milestoneId}/complete`);
  return response.data;
};

export const approveMilestoneRequest = async (milestoneId, feedback = null) => {
  const response = await api.post(`/projects/milestones/${milestoneId}/approve`, null, {
    params: { feedback }
  });
  return response.data;
};

export const rejectMilestoneRequest = async (milestoneId, feedback) => {
  const response = await api.post(`/projects/milestones/${milestoneId}/reject`, null, {
    params: { feedback }
  });
  return response.data;
};

export const getMilestonesAwaitingApproval = async () => {
  const response = await api.get('/projects/milestones/awaiting-approval');
  return response.data;
};

export const getMilestoneReport = async (milestoneId) => {
  const response = await api.get(`/projects/milestones/${milestoneId}/report`);
  return response.data;
};

export const connectProjectToSync = async (projectId, connectionData) => {
  const response = await api.patch(`/projects/${projectId}/sync-group`, connectionData);
  return response.data;
};

export const setProjectPocOwner = async (projectId, pocOwnerId) => {
  const response = await api.patch(`/projects/${projectId}/poc-owner`, { poc_owner_id: pocOwnerId });
  return response.data;
};

export const setManualPlannedSessions = async (projectId, plannedTotalSessions) => {
  const response = await api.patch(`/projects/${projectId}/planned-sessions`, { planned_total_sessions: plannedTotalSessions });
  return response.data;
};

// What the competition matcher proposed for this project and who acted on it:
// { matched, admin_selected, student_selected, runs }. Reviewer-gated — a
// student calling this gets 403, which is why the project page only asks for
// it for the roles that can read it.
export const getProjectCompetitionActivity = async (projectId) => {
  const response = await api.get(`/projects/${projectId}/competition-activity`);
  return response.data;
};
